{
  "title": "Blade Ward",
  "source": "Player's Handbook",
  "levelAndSchool": "Abjuration cantrip",
  "level": 0,
  "castingTime": "1 action",
  "range": "Self",
  "components": "V, S",
  "duration": "1 round",
  "description": [
    "You extend your hand and trace a sigil of warding in the air. Until the end of your next turn, you have resistance against bludgeoning, piercing, and slashing damage dealt by weapon attacks."
  ],
  "spellLists": ["bard", "eldritch-knight", "arcane-trickster", "sorcerer", "warlock", "wizard"]
}
